import { chainReducers } from 'src/utils/chainReducers';
import { KeyPhrasePinInputState } from 'src/react/keyPhrasePinInput/state/KeyPhrasePinInputState';
import { keyPhrasePinInputResetReducer } from 'src/react/keyPhrasePinInput/reducers/keyPhrasePinInputResetReducer';
import { keyPhrasePinInputSearchReducer } from 'src/react/keyPhrasePinInput/reducers/keyPhrasePinInputSearchReducer';

export const keyPhrasePinInputReducer = chainReducers<KeyPhrasePinInputState>(
    keyPhrasePinInputResetReducer,
    keyPhrasePinInputSearchReducer,
);
